import { Icon } from "@ugitgud/legos/ui/icon/Icon";
import { SvgArrowLineRight } from "@ugitgud/legos/ui/icon/SVG/ArrowLineRight";
import { SvgMiscX } from "@ugitgud/legos/ui/icon/SVG/MiscX";
import classNames from "classnames";
import { SvgGameTracklock } from "@ugitgud/legos/ui/icon/SVG/GameTracklock";
import { SvgLolUggLogoBlue } from "@ugitgud/legos/ui/icon/SVG/LolUggLogoBlue";

export const TRACKLOCK_BANNER_CTA = "app-tracklock";

interface HighlightsBannerProps {
  url: string;
  className?: string;
  onClick: (url: string) => void;
  onClose?: () => void;
  utmSource?: string;
}

export function TracklockBanner(props: HighlightsBannerProps) {
  const { url, onClick, onClose, className, utmSource } = props;

  const href = utmSource ? `${url}?utm_source=${utmSource}` : url;

  const onUrlClick = (e: React.MouseEvent) => {
    e.preventDefault();
    onClick(href);
  };

  return (
    <div className={classNames("w-full h-[48px] bg-[#000131] flex justify-end relative overflow-hidden", className)}>
      <div
        className="relative h-[48px] w-[1516px] shrink-0"
        style={{
          aspectRatio: `379/12`,
          background: `url('https://static.bigbrain.gg/assets/ugg/cta/tracklock-banner-bg.jpg') right -495px top -695px / 131.926% 3125% no-repeat`,
        }}
      >
        {/* Fade the left edge of the image into #000131 */}
        <div
          aria-hidden
          className="pointer-events-none absolute inset-0"
          style={{
            background: "linear-gradient(90deg, #000131 0%, rgba(0, 1, 49, 0.00) 35%)",
          }}
        />
      </div>
      {/* Full-bleed gradient anchored to screen left */}
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0 z-[1]"
        style={{
          background: "linear-gradient(90deg, #000131 0%, rgba(0, 1, 49, 0.00) 75.79%)",
        }}
      />
      <div
        className={classNames(
          "absolute inset-0 z-10 flex items-center justify-between sm:justify-center gap-[36px] px-8 text-white pt-[5px] pb-[6px]",
          {
            "pr-10": onClose,
          },
        )}
      >
        <div className="flex-shrink-0 items-center hidden sm:flex">
          <Icon
            icon={<SvgGameTracklock />}
            className="h-[36px] w-auto text-[#EFDEBF] drop-shadow-[0px_1px_0px_rgba(0,_0,_0,_0.40)]"
          />
          <Icon
            icon={<SvgMiscX />}
            className="h-[16px] text-[#ffffff99] drop-shadow-[0px_1px_0px_rgba(0,_0,_0,_0.40)] ml-[12px]"
          />
          <Icon
            icon={<SvgLolUggLogoBlue />}
            className="h-[26px] w-[80px] drop-shadow-[0px_1px_0px_rgba(0,_0,_0,_0.40)] ml-[12px]"
          />
        </div>
        <div className="[text-shadow:0px_1px_0px_rgba(0,_0,_0,_0.50)]">
          <div className="font-bold text-[18px] text-white">
            <span className="!font-barlow-condensed uppercase">Tracklock.gg Joins the U.GG Family!</span>
          </div>
          <div className="font-inter xs:flex hidden text-[12px] text-white">Deadlock stats, profiles, tier lists, and more.</div>
        </div>
        <div
          className="flex items-center justify-between h-[30px] bg-white rounded-sm py-1.5 pl-2 pr-1 cursor-pointer whitespace-nowrap hover:bg-white/80 drop-shadow-[0px_1px_0px_rgba(0,_0,_0,_0.40)]"
          onClick={onUrlClick}
        >
          <span className="font-bold text-[11px] text-[#000131]">View Deadlock Stats</span>
          <Icon icon={<SvgArrowLineRight />} className="w-6 h-6 text-[#3273FA]" />
        </div>
      </div>
      {onClose && (
        <div
          className="absolute z-20 top-[50%] right-[12px] translate-y-[-50%] p-[6px] cursor-pointer hover:opacity-50"
          onClick={onClose}
        >
          <Icon icon={<SvgMiscX />} size="xs" className="fill-white drop-shadow-[0px_1px_0px_rgba(0,_0,_0,_0.50)]" />
        </div>
      )}
    </div>
  );
}
